module.exports = __webpack_public_path__ + "2da4bb974f777f45e0398ac1ba44e507.svg";